import { alphanumericCnpj } from '@/shared/utils/cnpj';

export default function (document: any) {
  if (document) {
    document = typeof document !== 'string' ? document.toString() : document;
    const toDocument = () => {
      if (document.length === 14) {
        document = alphanumericCnpj(document);
        document = document.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, '$1.$2.$3/$4-$5');
        return document;
      }
      document = document.padStart(11, '0');
      document = document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      return document;
    };
    return toDocument();
  }
  return document;
}
